import { currencyFormatter, formatPrintDate, formatLongDate } from './utils'

export function getTDForPrint(state) {
  var result = '';
  result += `Date of injury: ${formatLongDate(state.doi)}\n\n`;

  if (state.isManualAww) {
    result += `Work period start\tWork period end\tWage\n\n`;
    state.awwArray.forEach(row => {
      result += `${formatPrintDate(row.startDate)}\t${formatPrintDate(row.endDate)}\t${row.wage}\n`;
    });
    result += '\n';
  }

  result += `Average weekly wage: ${state.aww}\n`;
  result += `${state.pdRateText}: ${state.pdRate}\n\n`;

  if (state.startDate < state.endDate) {
    result += `Week / days: ${state.weeks} / ${state.days}\n`;
    result += `Total days: ${state.totalDays}\n\n`;

    let start = formatPrintDate(state.startDate);
    let end = formatPrintDate(state.endDate);
    let amount = currencyFormatter.format(state.amount);
    result += `Total TD liability for period ${start} - ${formatPrintDate(end)}: ${amount}\n\n`;
  }

  //result += "--------------------------------------------------------------\nCompCalc Plus: “the Complex made Simple ...”\n";
  return result;
}
